export const snakeColumns =(arr: any[]) => {
    const middle = Math.ceil(arr.length / 2);

    const col1 = arr.slice(0, middle);   
    const col2 = arr.slice(middle);      

    const merged: any[] = [];

    for (let i = 0; i < col1.length; i++) {
      merged.push(col1[i]);
      if (col2[i]) merged.push(col2[i]);
    }

    return merged;
  }